import * as React from 'react';
import { IconChevronLeft16 } from '@cian/ui-kit/icons';
import * as styles from './GradientRoundArrowLeft.css';
import { GRADIENT_ARROW_WIDTH } from '../../../constants/arrows';

interface IGradientRoundArrowLeftProps {
  onClick(): void;
  topOffset?: number;
}

export const GradientRoundArrowLeft: React.FC<IGradientRoundArrowLeftProps> = ({ onClick, topOffset }) => {
  const offsetStyle =
    topOffset !== undefined
      ? {
          top: `${topOffset}px`,
          alignSelf: 'start',
        }
      : undefined;

  return (
    <div
      style={{ width: `${GRADIENT_ARROW_WIDTH}px`, ...offsetStyle }}
      className={styles['arrow']}
      onClick={onClick}
      data-testid="GradientRoundArrowLeft"
    >
      <div className={styles['icon-wrapper']}>
        <IconChevronLeft16 color="gray_icons_100" />
      </div>
    </div>
  );
};
